var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g2, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g3, _path54, _path55, _path56, _path57, _g4, _path58, _path59, _path60, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragDropImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1028,
    height: 1088,
    viewBox: "0 0 1028 1088",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3762_33256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.07 28.96H533.78C521.8 28.96 512.09 38.67 512.09 50.65V354C358.9 354 205.71 354 52.53 354C37.15 354 30.08 362.26 30.08 380.19C30.08 596.51 30.08 812.84 30.08 1029.16C30.08 1047.28 37.17 1055.39 53.03 1055.39C218.36 1055.39 383.69 1055.39 549.03 1055.39C565.07 1055.39 572.02 1047.28 572.02 1028.58C572.02 989.63 572.02 950.68 572.02 911.73H976.07C988.05 911.73 997.76 902.02 997.76 890.04V50.65C997.76 38.67 988.05 28.96 976.07 28.96Z",
    fill: "#FFE4EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M976.07 28.96H533.79C521.811 28.96 512.1 38.6709 512.1 50.65V890.05C512.1 902.029 521.811 911.74 533.79 911.74H976.07C988.049 911.74 997.76 902.029 997.76 890.05V50.65C997.76 38.6709 988.049 28.96 976.07 28.96Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M965.68 39.4697H544.86C532.881 39.4697 523.17 49.1807 523.17 61.1597V877.76C523.17 889.739 532.881 899.45 544.86 899.45H965.68C977.659 899.45 987.37 889.739 987.37 877.76V61.1597C987.37 49.1807 977.659 39.4697 965.68 39.4697Z",
    fill: "url(#paint0_linear_3762_33256)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M937.55 643.85C952.241 643.85 964.15 631.941 964.15 617.25C964.15 602.56 952.241 590.65 937.55 590.65C922.859 590.65 910.95 602.56 910.95 617.25C910.95 631.941 922.859 643.85 937.55 643.85Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M697.54 812.46H571.72C568.677 812.46 566.21 814.925 566.21 817.965C566.21 821.005 568.677 823.47 571.72 823.47H697.54C700.583 823.47 703.05 821.005 703.05 817.965C703.05 814.925 700.583 812.46 697.54 812.46Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M657.29 783.84H531.47C528.427 783.84 525.96 786.304 525.96 789.345C525.96 792.385 528.427 794.85 531.47 794.85H657.29C660.333 794.85 662.8 792.385 662.8 789.345C662.8 786.304 660.333 783.84 657.29 783.84Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M640.3 840.56H568.14C565.097 840.56 562.63 843.024 562.63 846.065C562.63 849.105 565.097 851.57 568.14 851.57H640.3C643.343 851.57 645.81 849.105 645.81 846.065C645.81 843.024 643.343 840.56 640.3 840.56Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M937.54 708.17C937.03 708.17 936.6 707.98 936.25 707.61L921.03 691.73C919.94 690.64 919.12 689.38 918.59 687.96C918.05 686.54 917.82 685.08 917.87 683.56C917.93 682.05 918.31 680.6 919 679.23C919.79 677.67 920.88 676.38 922.28 675.35C923.68 674.33 925.23 673.68 926.94 673.4C928.65 673.12 930.33 673.25 931.98 673.78C933.63 674.31 935.07 675.2 936.31 676.43L937.53 677.65L938.75 676.43C939.98 675.2 941.43 674.31 943.08 673.78C944.73 673.24 946.42 673.11 948.14 673.38C949.86 673.65 951.43 674.3 952.84 675.34C954.25 676.38 955.34 677.67 956.1 679.23C956.77 680.6 957.15 682.05 957.22 683.56C957.29 685.07 957.05 686.53 956.5 687.94C955.95 689.35 955.14 690.6 954.07 691.69L938.82 707.61C938.47 707.98 938.04 708.17 937.53 708.17H937.54ZM928.67 676.86C927.2 676.86 925.87 677.26 924.66 678.06C923.45 678.86 922.57 679.94 922.01 681.29C921.45 682.64 921.31 684.04 921.59 685.48C921.87 686.92 922.52 688.16 923.55 689.18L937.55 703.81L951.55 689.18C952.64 688.09 953.32 686.77 953.57 685.24C953.82 683.71 953.61 682.24 952.91 680.84C952.4 679.79 951.67 678.93 950.73 678.24C949.79 677.55 948.74 677.12 947.59 676.93C946.44 676.74 945.31 676.83 944.2 677.19C943.09 677.55 942.13 678.14 941.32 678.95L938.84 681.46C938.49 681.81 938.07 681.98 937.57 681.98C937.07 681.98 936.64 681.81 936.3 681.46L933.82 678.95C933.14 678.28 932.36 677.76 931.46 677.4C930.56 677.04 929.64 676.86 928.68 676.86H928.67Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M928.88 760.58C928.5 760.58 928.17 760.44 927.88 760.15C927.59 759.86 927.45 759.53 927.45 759.15V754.8H925.04C924.43 754.8 923.87 754.65 923.36 754.34C922.85 754.03 922.45 753.63 922.14 753.12C921.83 752.61 921.68 752.05 921.68 751.44V732.21C921.68 731.6 921.83 731.04 922.14 730.53C922.45 730.02 922.85 729.62 923.36 729.31C923.87 729 924.43 728.85 925.04 728.85H950.05C950.66 728.85 951.22 729 951.73 729.31C952.24 729.62 952.64 730.02 952.95 730.53C953.26 731.04 953.41 731.6 953.41 732.21V751.44C953.41 752.05 953.26 752.61 952.95 753.12C952.64 753.63 952.24 754.04 951.73 754.34C951.22 754.64 950.66 754.8 950.05 754.8H937.07L929.77 760.29C929.52 760.48 929.22 760.58 928.88 760.58ZM925.04 731.73C924.91 731.73 924.8 731.78 924.71 731.87C924.62 731.96 924.57 732.08 924.57 732.2V751.43C924.57 751.58 924.62 751.69 924.71 751.78C924.81 751.86 924.92 751.91 925.04 751.91H928.88C929.28 751.91 929.63 752.05 929.91 752.34C930.19 752.63 930.34 752.97 930.34 753.37V756.26L935.7 752.2C935.95 752.01 936.25 751.91 936.59 751.91H950.05C950.18 751.91 950.29 751.86 950.38 751.77C950.47 751.68 950.52 751.56 950.52 751.44V732.21C950.52 732.08 950.47 731.97 950.38 731.88C950.29 731.79 950.17 731.74 950.05 731.74H925.04V731.73Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M572.02 704.97C572.02 812.84 572.02 920.72 572.02 1028.59C572.02 1047.29 565.07 1055.4 549.03 1055.4C383.7 1055.4 218.36 1055.4 53.03 1055.4C37.16 1055.4 30.08 1047.29 30.08 1029.17C30.08 812.85 30.08 596.52 30.08 380.2C30.08 362.27 37.16 354.01 52.53 354.01C218.2 354.01 383.86 354.01 549.53 354.01C564.88 354.01 572.01 362.31 572.02 380.21C572.02 488.47 572.02 596.73 572.02 704.99V704.97ZM301.01 931.43C378 931.43 454.99 931.43 531.98 931.43C547.87 931.43 556.04 923.32 556.04 907.54C556.04 768.56 556.04 629.57 556.04 490.59C556.04 474.45 547.96 466.38 531.77 466.38C378.29 466.38 224.81 466.38 71.33 466.38C55.14 466.38 46.99 474.47 46.99 490.55C46.99 629.53 46.99 768.52 46.99 907.5C46.99 923.29 55.2 931.43 71.04 931.43C147.7 931.43 224.35 931.43 301.01 931.43ZM302.16 1033.43C379.81 1033.43 457.46 1033.43 535.11 1033.43C549.53 1033.43 558.02 1024.89 558.04 1010.42C558.06 998.59 558.07 986.76 558.04 974.93C558.01 961.14 549.41 952.4 535.61 952.4C380.14 952.37 224.67 952.37 69.2 952.4C55.74 952.4 47.09 961.18 47 974.67C46.92 986.17 46.97 997.67 46.98 1009.16C47 1025.35 55.06 1033.43 71.19 1033.43C148.17 1033.43 225.16 1033.43 302.14 1033.43H302.16Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M301.01 931.43C224.35 931.43 147.7 931.43 71.04 931.43C55.2 931.43 46.99 923.29 46.99 907.5C46.99 768.52 46.99 629.53 46.99 490.55C46.99 474.47 55.15 466.38 71.33 466.38C224.81 466.38 378.29 466.38 531.77 466.38C547.96 466.38 556.04 474.46 556.04 490.59C556.04 629.57 556.04 768.56 556.04 907.54C556.04 923.32 547.87 931.43 531.98 931.43C454.99 931.43 378 931.43 301.01 931.43Z",
    fill: "url(#paint1_linear_3762_33256)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.16 1033.43C225.18 1033.43 148.19 1033.43 71.21 1033.43C55.0799 1033.43 47.0099 1025.35 46.9999 1009.16C46.9899 997.659 46.9399 986.159 47.0199 974.669C47.1099 961.169 55.76 952.399 69.22 952.399C224.69 952.369 380.16 952.369 535.63 952.399C549.43 952.399 558.02 961.139 558.06 974.929C558.09 986.759 558.08 998.589 558.06 1010.42C558.04 1024.89 549.55 1033.43 535.13 1033.43C457.48 1033.44 379.83 1033.43 302.18 1033.43H302.16Z",
    fill: "#EAE6FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4799 1009.32C87.0599 1009.32 86.7099 1009.17 86.4199 1008.86L73.9399 995.83C73.0399 994.93 72.3699 993.9 71.9399 992.74C71.4999 991.58 71.3099 990.37 71.3499 989.13C71.3999 987.89 71.7099 986.71 72.2799 985.58C72.9299 984.3 73.8299 983.24 74.9699 982.4C76.1099 981.56 77.3899 981.03 78.7899 980.8C80.1899 980.57 81.5699 980.68 82.9299 981.12C84.2799 981.56 85.4699 982.28 86.4799 983.3L87.4799 984.3L88.4799 983.3C89.4899 982.29 90.6699 981.56 92.0299 981.12C93.3899 980.68 94.7699 980.57 96.1799 980.79C97.5899 981.01 98.8799 981.54 100.03 982.39C101.18 983.24 102.08 984.3 102.71 985.58C103.26 986.71 103.57 987.89 103.63 989.13C103.69 990.37 103.49 991.57 103.04 992.72C102.59 993.88 101.93 994.9 101.05 995.8L88.5399 1008.86C88.2499 1009.17 87.8999 1009.32 87.4799 1009.32ZM80.2099 983.64C79.0099 983.64 77.9099 983.97 76.9199 984.63C75.9299 985.29 75.1999 986.17 74.7399 987.28C74.2799 988.39 74.1699 989.53 74.3999 990.72C74.6299 991.9 75.1599 992.92 75.9999 993.76L87.4799 1005.76L98.9599 993.76C99.8599 992.86 100.41 991.78 100.62 990.52C100.83 989.26 100.65 988.06 100.08 986.91C99.6599 986.05 99.0599 985.34 98.2899 984.78C97.5199 984.22 96.6599 983.86 95.7099 983.71C94.7699 983.56 93.8399 983.63 92.9299 983.92C92.0199 984.22 91.2399 984.7 90.5699 985.37L88.5399 987.43C88.2499 987.72 87.8999 987.86 87.4899 987.86C87.0799 987.86 86.7299 987.72 86.4399 987.43L84.4099 985.37C83.8599 984.82 83.2099 984.39 82.4799 984.1C81.7499 983.8 80.9899 983.66 80.1999 983.66L80.2099 983.64Z",
    fill: "#4B4BDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.37 1009.74C126.02 1009.74 125.71 1009.61 125.44 1009.34C125.17 1009.07 125.04 1008.77 125.04 1008.41V1004.37H122.8C122.23 1004.37 121.71 1004.23 121.24 1003.94C120.77 1003.65 120.39 1003.28 120.11 1002.8C119.82 1002.33 119.68 1001.81 119.68 1001.24V983.37C119.68 982.8 119.82 982.28 120.11 981.81C120.39 981.34 120.77 980.96 121.24 980.68C121.71 980.4 122.23 980.25 122.8 980.25H146.04C146.61 980.25 147.13 980.39 147.6 980.68C148.07 980.97 148.45 981.34 148.73 981.81C149.02 982.28 149.16 982.8 149.16 983.37V1001.24C149.16 1001.81 149.02 1002.33 148.73 1002.8C148.45 1003.27 148.07 1003.65 147.6 1003.94C147.13 1004.23 146.61 1004.37 146.04 1004.37H133.98L127.2 1009.47C126.96 1009.65 126.69 1009.74 126.37 1009.74ZM122.8 982.93C122.68 982.93 122.58 982.98 122.49 983.06C122.4 983.14 122.36 983.25 122.36 983.37V1001.24C122.36 1001.38 122.4 1001.49 122.49 1001.56C122.58 1001.64 122.68 1001.68 122.8 1001.68H126.37C126.74 1001.68 127.06 1001.81 127.33 1002.08C127.6 1002.35 127.73 1002.67 127.73 1003.04V1005.72L132.71 1001.95C132.95 1001.77 133.22 1001.68 133.54 1001.68H146.04C146.16 1001.68 146.26 1001.63 146.35 1001.55C146.44 1001.47 146.48 1001.36 146.48 1001.24V983.37C146.48 983.25 146.44 983.15 146.35 983.06C146.26 982.97 146.16 982.93 146.04 982.93H122.8Z",
    fill: "#4B4BDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3299 443.29C116.743 443.29 130.86 429.174 130.86 411.76C130.86 394.347 116.743 380.23 99.3299 380.23C81.9164 380.23 67.7999 394.347 67.7999 411.76C67.7999 429.174 81.9164 443.29 99.3299 443.29Z",
    fill: "url(#paint2_linear_3762_33256)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M281.19 396.11H155.37C152.327 396.11 149.86 398.575 149.86 401.615C149.86 404.656 152.327 407.12 155.37 407.12H281.19C284.233 407.12 286.7 404.656 286.7 401.615C286.7 398.575 284.233 396.11 281.19 396.11Z",
    fill: "url(#paint3_linear_3762_33256)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.53 415.27H155.37C152.327 415.27 149.86 417.734 149.86 420.775C149.86 423.815 152.327 426.28 155.37 426.28H227.53C230.573 426.28 233.04 423.815 233.04 420.775C233.04 417.734 230.573 415.27 227.53 415.27Z",
    fill: "url(#paint4_linear_3762_33256)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399.01 419.79C395.06 419.79 392.03 417.63 392.03 414.14H395.49C395.63 415.76 396.77 417.06 399.01 417.06C401.25 417.06 402.56 415.84 402.56 414.16C402.56 409.39 392.09 412.49 392.09 405.22C392.09 401.76 394.84 399.6 398.87 399.6C402.64 399.6 405.31 401.59 405.6 404.97H402.02C401.91 403.64 400.74 402.41 398.7 402.36C396.83 402.3 395.38 403.21 395.38 405.11C395.38 409.57 405.83 406.78 405.83 413.99C405.83 416.94 403.42 419.78 399.02 419.78L399.01 419.79Z",
    fill: "#4B4BDE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M418.33 403.69C422.45 403.69 425.68 406.87 425.68 411.69C425.68 416.51 422.44 419.84 418.33 419.84C415.75 419.84 413.9 418.53 412.88 417.31V427.02H409.65V403.94H412.88V406.24C413.87 404.93 415.78 403.69 418.33 403.69ZM417.62 406.5C415.21 406.5 412.88 408.4 412.88 411.75C412.88 415.1 415.21 417.03 417.62 417.03C420.03 417.03 422.39 415.07 422.39 411.69C422.39 408.31 420.06 406.5 417.62 406.5Z",
    fill: "#4B4BDE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M435.67 419.84C431.21 419.84 427.84 416.66 427.84 411.75C427.84 406.84 431.36 403.69 435.82 403.69C440.28 403.69 443.8 406.84 443.8 411.75C443.8 416.66 440.17 419.84 435.68 419.84H435.67ZM435.67 417.03C438.08 417.03 440.47 415.3 440.47 411.75C440.47 408.2 438.17 406.5 435.76 406.5C433.35 406.5 431.13 408.2 431.13 411.75C431.13 415.3 433.23 417.03 435.67 417.03Z",
    fill: "#4B4BDE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M458.09 410.85C458.09 407.98 456.53 406.51 454.17 406.51C451.81 406.51 450.22 407.99 450.22 410.85V419.59H446.98V403.95H450.22V405.74C451.27 404.46 453 403.7 454.88 403.7C458.54 403.7 461.3 406 461.3 410.37V419.59H458.09V410.85Z",
    fill: "#4B4BDE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M471.08 419.84C467.33 419.84 464.69 417.63 464.55 414.79H467.9C468.01 416.07 469.23 417.12 471.02 417.12C472.81 417.12 473.89 416.33 473.89 415.25C473.89 412.18 464.81 413.94 464.81 408.21C464.81 405.71 467.14 403.7 470.83 403.7C474.52 403.7 476.7 405.6 476.88 408.72H473.64C473.53 407.36 472.48 406.42 470.72 406.42C468.96 406.42 468.08 407.13 468.08 408.18C468.08 411.33 476.91 409.57 477.08 415.22C477.08 417.86 474.78 419.85 471.09 419.85L471.08 419.84Z",
    fill: "#4B4BDE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M487.34 419.84C482.88 419.84 479.51 416.66 479.51 411.75C479.51 406.84 483.03 403.69 487.49 403.69C491.95 403.69 495.47 406.84 495.47 411.75C495.47 416.66 491.84 419.84 487.35 419.84H487.34ZM487.34 417.03C489.75 417.03 492.14 415.3 492.14 411.75C492.14 408.2 489.84 406.5 487.43 406.5C485.02 406.5 482.8 408.2 482.8 411.75C482.8 415.3 484.9 417.03 487.34 417.03Z",
    fill: "#4B4BDE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M501.9 419.59H498.66V403.95H501.9V406.22C502.81 404.66 504.37 403.69 506.58 403.69V407.04H505.76C503.38 407.04 501.9 408.03 501.9 411.35V419.58V419.59Z",
    fill: "#4B4BDE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M516.28 419.84C511.8 419.84 508.47 416.66 508.47 411.75C508.47 406.84 511.65 403.69 516.28 403.69C520.91 403.69 523.89 406.78 523.89 411.38C523.89 411.92 523.86 412.43 523.78 412.97H511.83C512.06 415.55 513.9 417.11 516.29 417.11C518.28 417.11 519.38 416.14 519.98 414.92H523.47C522.59 417.64 520.12 419.83 516.29 419.83L516.28 419.84ZM511.85 410.36H520.51C520.45 407.95 518.55 406.41 516.14 406.41C513.95 406.41 512.19 407.89 511.85 410.36Z",
    fill: "#4B4BDE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M533.39 403.69C535.43 403.69 537.59 404.66 538.78 406.13V398.58H542.04V419.58H538.78V417.22C537.79 418.64 535.91 419.83 533.36 419.83C529.24 419.83 525.98 416.51 525.98 411.68C525.98 406.85 529.25 403.68 533.39 403.68V403.69ZM534.04 406.5C531.63 406.5 529.3 408.32 529.3 411.69C529.3 415.06 531.63 417.03 534.04 417.03C536.45 417.03 538.78 415.13 538.78 411.75C538.78 408.37 536.48 406.5 534.04 406.5Z",
    fill: "#4B4BDE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M818.72 90.65C814.77 90.65 811.74 88.49 811.74 85H815.2C815.34 86.62 816.48 87.92 818.72 87.92C820.96 87.92 822.27 86.7 822.27 85.02C822.27 80.25 811.8 83.35 811.8 76.08C811.8 72.62 814.55 70.46 818.58 70.46C822.35 70.46 825.02 72.45 825.31 75.83H821.73C821.62 74.5 820.45 73.27 818.41 73.22C816.54 73.16 815.09 74.07 815.09 75.97C815.09 80.43 825.54 77.64 825.54 84.85C825.54 87.8 823.13 90.64 818.73 90.64L818.72 90.65Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M838.04 74.5605C842.16 74.5605 845.39 77.7405 845.39 82.5605C845.39 87.3805 842.15 90.7105 838.04 90.7105C835.46 90.7105 833.61 89.4005 832.59 88.1805V97.8905H829.36V74.8105H832.59V77.1105C833.58 75.8005 835.49 74.5605 838.04 74.5605ZM837.33 77.3706C834.92 77.3706 832.59 79.2706 832.59 82.6206C832.59 85.9706 834.92 87.9006 837.33 87.9006C839.74 87.9006 842.1 85.9405 842.1 82.5605C842.1 79.1805 839.77 77.3706 837.33 77.3706Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M855.38 90.7105C850.92 90.7105 847.55 87.5306 847.55 82.6206C847.55 77.7106 851.07 74.5605 855.53 74.5605C859.99 74.5605 863.51 77.7106 863.51 82.6206C863.51 87.5306 859.88 90.7105 855.39 90.7105H855.38ZM855.38 87.9006C857.79 87.9006 860.18 86.1706 860.18 82.6206C860.18 79.0706 857.88 77.3706 855.47 77.3706C853.06 77.3706 850.84 79.0706 850.84 82.6206C850.84 86.1706 852.94 87.9006 855.38 87.9006Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M877.8 81.7105C877.8 78.8405 876.24 77.3706 873.88 77.3706C871.52 77.3706 869.93 78.8505 869.93 81.7105V90.4505H866.69V74.8105H869.93V76.6005C870.98 75.3205 872.71 74.5605 874.59 74.5605C878.25 74.5605 881.01 76.8606 881.01 81.2306V90.4505H877.8V81.7105Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M890.79 90.7103C887.04 90.7103 884.4 88.5003 884.26 85.6603H887.61C887.72 86.9403 888.94 87.9903 890.73 87.9903C892.52 87.9903 893.6 87.2003 893.6 86.1203C893.6 83.0503 884.52 84.8103 884.52 79.0803C884.52 76.5803 886.85 74.5703 890.54 74.5703C894.23 74.5703 896.41 76.4703 896.59 79.5903H893.35C893.24 78.2303 892.19 77.2903 890.43 77.2903C888.67 77.2903 887.79 78.0003 887.79 79.0503C887.79 82.2003 896.62 80.4403 896.79 86.0903C896.79 88.7303 894.49 90.7203 890.8 90.7203L890.79 90.7103Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M907.05 90.7105C902.59 90.7105 899.22 87.5306 899.22 82.6206C899.22 77.7106 902.74 74.5605 907.2 74.5605C911.66 74.5605 915.18 77.7106 915.18 82.6206C915.18 87.5306 911.55 90.7105 907.06 90.7105H907.05ZM907.05 87.9006C909.46 87.9006 911.85 86.1706 911.85 82.6206C911.85 79.0706 909.55 77.3706 907.14 77.3706C904.73 77.3706 902.51 79.0706 902.51 82.6206C902.51 86.1706 904.61 87.9006 907.05 87.9006Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M921.61 90.4605H918.37V74.8205H921.61V77.0905C922.52 75.5305 924.08 74.5605 926.29 74.5605V77.9106H925.47C923.09 77.9106 921.61 78.9006 921.61 82.2206V90.4505V90.4605Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M935.99 90.7105C931.51 90.7105 928.18 87.5306 928.18 82.6206C928.18 77.7106 931.36 74.5605 935.99 74.5605C940.62 74.5605 943.6 77.6505 943.6 82.2505C943.6 82.7905 943.57 83.3005 943.49 83.8405H931.54C931.77 86.4205 933.61 87.9806 936 87.9806C937.99 87.9806 939.09 87.0106 939.69 85.7906H943.18C942.3 88.5106 939.83 90.7005 936 90.7005L935.99 90.7105ZM931.56 81.2306H940.22C940.16 78.8206 938.26 77.2805 935.85 77.2805C933.66 77.2805 931.9 78.7606 931.56 81.2306Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M953.11 74.5602C955.15 74.5602 957.31 75.5302 958.5 77.0002V69.4502H961.76V90.4502H958.5V88.0902C957.51 89.5102 955.63 90.7002 953.08 90.7002C948.96 90.7002 945.7 87.3802 945.7 82.5502C945.7 77.7202 948.97 74.5502 953.11 74.5502V74.5602ZM953.76 77.3702C951.35 77.3702 949.02 79.1902 949.02 82.5602C949.02 85.9302 951.35 87.9002 953.76 87.9002C956.17 87.9002 958.5 86.0002 958.5 82.6202C958.5 79.2402 956.2 77.3702 953.76 77.3702Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M192.45 983.05C192.22 983.86 191.69 984.52 191.28 985.23C190.38 986.78 189.46 988.32 188.55 989.87C187.29 992 186.03 994.14 184.76 996.27C183.46 998.46 182.17 1000.65 180.88 1002.85C180.19 1004.02 179.51 1005.18 178.81 1006.35C178.32 1007.16 177.24 1007.24 176.65 1006.5C176.51 1006.33 176.42 1006.11 176.37 1005.9C175.84 1003.83 175.31 1001.75 174.79 999.68C174.25 997.55 173.71 995.42 173.19 993.29C173.12 993.02 173.01 992.82 172.81 992.63C169.9 989.78 166.99 986.93 164.08 984.07C163.89 983.88 163.68 983.7 163.5 983.5C162.79 982.74 163.13 981.55 164.12 981.32C164.18 981.31 164.24 981.3 164.3 981.3C165.64 981.3 166.98 981.29 168.32 981.3C171.45 981.33 174.59 981.38 177.72 981.42C180.38 981.46 183.03 981.5 185.69 981.54C187.5 981.57 189.3 981.61 191.11 981.64C191.77 981.65 192.25 982.05 192.39 982.68C192.39 982.72 192.43 982.76 192.45 982.79V983.04V983.05ZM187.46 986.46C187.35 986.53 187.24 986.59 187.13 986.65C186.07 987.23 185.01 987.81 183.94 988.4C181.33 989.83 178.73 991.27 176.12 992.71C176.01 992.77 175.85 992.81 175.81 992.91C175.77 993 175.84 993.15 175.87 993.28C176.28 994.89 176.69 996.5 177.09 998.1C177.43 999.44 177.76 1000.77 178.1 1002.11C178.11 1002.16 178.14 1002.21 178.16 1002.27C178.56 1001.72 187.45 986.61 187.45 986.47L187.46 986.46ZM174.49 990.61C178.35 988.48 182.21 986.37 186.06 984.25C186.06 984.24 186.06 984.22 186.05 984.21C179.95 984.13 173.86 984.04 167.76 983.96C167.76 983.97 167.74 983.99 167.73 984C169.98 986.21 172.23 988.41 174.49 990.62V990.61Z",
    fill: "#4B4BDE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M954.61 788.909C954.34 789.849 953.73 790.619 953.25 791.449C952.21 793.259 951.13 795.049 950.07 796.839C948.6 799.319 947.13 801.799 945.67 804.289C944.16 806.839 942.66 809.389 941.15 811.939C940.35 813.299 939.55 814.659 938.74 816.009C938.17 816.949 936.92 817.049 936.22 816.189C936.06 815.989 935.96 815.729 935.89 815.489C935.27 813.079 934.66 810.669 934.05 808.249C933.42 805.769 932.8 803.299 932.18 800.819C932.1 800.509 931.97 800.269 931.74 800.049C928.35 796.739 924.97 793.419 921.59 790.099C921.36 789.879 921.13 789.669 920.91 789.439C920.08 788.559 920.48 787.179 921.63 786.899C921.7 786.879 921.77 786.879 921.84 786.879C923.4 786.879 924.96 786.869 926.52 786.879C930.16 786.919 933.81 786.969 937.45 787.019C940.54 787.059 943.63 787.109 946.72 787.159C948.82 787.189 950.92 787.239 953.02 787.279C953.78 787.289 954.35 787.759 954.51 788.489C954.52 788.539 954.56 788.579 954.58 788.619V788.909H954.61ZM948.81 792.869C948.68 792.949 948.55 793.029 948.43 793.099C947.2 793.779 945.96 794.449 944.73 795.129C941.7 796.799 938.67 798.469 935.64 800.139C935.51 800.209 935.32 800.259 935.28 800.369C935.23 800.479 935.32 800.649 935.35 800.789C935.82 802.659 936.3 804.529 936.77 806.399C937.16 807.949 937.55 809.509 937.94 811.059C937.95 811.119 937.98 811.169 938.01 811.239C938.47 810.599 948.81 793.029 948.81 792.859V792.869ZM933.72 797.699C938.21 795.229 942.7 792.759 947.18 790.299C947.18 790.279 947.17 790.269 947.16 790.249C940.07 790.149 932.98 790.049 925.89 789.959C925.88 789.979 925.87 789.989 925.86 790.009C928.48 792.579 931.1 795.139 933.72 797.709V797.699Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38 536.18L388.45 686.79L296.26 845.24L204.31 687.38L296.38 536.18Z",
    fill: "#FF4D49"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M296.42 734.12C293.9 732.74 217.65 694.79 206.4 689.23C205.97 689.03 205.57 689.51 205.81 689.9L295.86 844.61L296.37 734.12H296.41H296.42Z",
    fill: "url(#paint5_linear_3762_33256)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M296.38 734.64L295.55 537.56L204.83 687.66L296.38 734.64Z",
    fill: "#FCE37C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M759.24 383.101L633.15 448.781C631.66 449.561 630.72 451.111 630.72 452.831L631.31 506.681L759.11 581.171C760.17 581.791 761.44 581.791 762.5 581.171L890.8 506.621L891.76 462.701L759.22 383.111L759.24 383.101Z",
    fill: "#26C6F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M760.81 582.4C760.09 582.4 759.38 582.21 758.72 581.82L630.54 507.11V506.67L629.94 452.82C629.94 450.8 631.03 448.99 632.79 448.08L759.27 382.2L759.64 382.42L892.56 462.24L891.58 507.05L762.9 581.82C762.25 582.21 761.53 582.4 760.81 582.4ZM632.08 506.21L759.5 580.48C760.32 580.96 761.29 580.96 762.11 580.48L890.04 506.15L890.99 463.12L759.21 383.99L633.5 449.46C632.26 450.11 631.49 451.39 631.49 452.82L632.08 506.22V506.21Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M890.87 446.031C891.74 446.431 891.83 447.621 891.06 448.151L765.19 527.801C763.82 528.611 764.07 526.931 762.7 526.121L633.74 452.541C632.56 451.861 632.56 450.111 633.8 449.491L773.65 375.721L890.9 446.001L890.87 446.031Z",
    fill: "#26C6F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M764.56 528.79C763.77 528.79 763.35 528.1 763.11 527.72C762.9 527.38 762.68 527.02 762.29 526.79L633.35 453.21C632.54 452.74 632.05 451.87 632.08 450.93C632.11 450 632.62 449.2 633.45 448.79L773.67 374.82L774.05 375.04L892.16 445.84L892.01 445.99C892.21 446.28 892.33 446.61 892.36 446.98C892.42 447.7 892.1 448.38 891.5 448.79L765.6 528.45C765.2 528.69 764.85 528.78 764.56 528.78V528.79ZM773.62 376.61L634.16 450.17C633.7 450.4 633.64 450.81 633.63 450.98C633.62 451.35 633.8 451.68 634.12 451.86L763.07 525.44C763.8 525.87 764.17 526.47 764.43 526.9C764.49 527 764.57 527.13 764.63 527.21C764.66 527.19 764.71 527.16 764.78 527.12L890.64 447.48C890.81 447.36 890.81 447.18 890.81 447.1C890.81 447.02 890.76 446.83 890.54 446.73L889.53 446.26L889.64 446.15L773.62 376.61Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3762_33256",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 760,
    y: 446,
    width: 133,
    height: 136
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M760.86 581.59L890.47 507.2C891.15 506.8 891.56 506.08 891.56 505.3L892.12 447.84C892.12 446.94 891.16 446.41 890.41 446.84L761.02 524.94",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3762_33256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M761.65 446.41H760.86V581.59H761.65V446.41Z",
    fill: "#26C6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.43 446.41H761.64V581.59H762.43V446.41Z",
    fill: "#26C5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.22 446.41H762.43V581.59H763.22V446.41Z",
    fill: "#26C4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.01 446.41H763.22V581.59H764.01V446.41Z",
    fill: "#25C2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.8 446.41H764.01V581.59H764.8V446.41Z",
    fill: "#25C1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.74 446.41H764.79V581.59H765.74V446.41Z",
    fill: "#25C1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.69 446.41H765.74V581.59H766.69V446.41Z",
    fill: "#25C0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.64 446.41H766.69V581.59H767.64V446.41Z",
    fill: "#25BFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.59 446.41H767.64V581.59H768.59V446.41Z",
    fill: "#25BEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.54 446.41H768.59V581.59H769.54V446.41Z",
    fill: "#25BDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.48 446.41H769.53V581.59H770.48V446.41Z",
    fill: "#24BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.43 446.41H770.48V581.59H771.43V446.41Z",
    fill: "#24BBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.38 446.41H771.43V581.59H772.38V446.41Z",
    fill: "#24BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.33 446.41H772.38V581.59H773.33V446.41Z",
    fill: "#24B9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.28 446.41H773.33V581.59H774.28V446.41Z",
    fill: "#24B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.22 446.41H774.27V581.59H775.22V446.41Z",
    fill: "#24B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.17 446.41H775.22V581.59H776.17V446.41Z",
    fill: "#24B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.12 446.41H776.17V581.59H777.12V446.41Z",
    fill: "#24B4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.07 446.41H777.12V581.59H778.07V446.41Z",
    fill: "#23B3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.02 446.41H778.07V581.59H779.02V446.41Z",
    fill: "#23B2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.96 446.41H779.01V581.59H779.96V446.41Z",
    fill: "#23B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.91 446.41H779.96V581.59H780.91V446.41Z",
    fill: "#23B0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.86 446.41H780.91V581.59H781.86V446.41Z",
    fill: "#23AFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.53 446.41H781.86V581.59H783.53V446.41Z",
    fill: "#23AFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.2 446.41H783.53V581.59H785.2V446.41Z",
    fill: "#23AEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.87 446.41H785.2V581.59H786.87V446.41Z",
    fill: "#23ADFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.54 446.41H786.87V581.59H788.54V446.41Z",
    fill: "#23ACFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.21 446.41H788.54V581.59H790.21V446.41Z",
    fill: "#23ABFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.88 446.41H790.21V581.59H791.88V446.41Z",
    fill: "#23AAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.55 446.41H791.88V581.59H793.55V446.41Z",
    fill: "#22A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.22 446.41H793.55V581.59H795.22V446.41Z",
    fill: "#22A7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.89 446.41H795.22V581.59H796.89V446.41Z",
    fill: "#22A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.56 446.41H796.89V581.59H798.56V446.41Z",
    fill: "#22A5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.23 446.41H798.56V581.59H800.23V446.41Z",
    fill: "#22A4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.79 446.41H800.23V581.59H806.79V446.41Z",
    fill: "#22A4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.36 446.41H806.8V581.59H813.36V446.41Z",
    fill: "#22A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.92 446.41H813.36V581.59H819.92V446.41Z",
    fill: "#22A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.8 446.41H819.92V581.59H821.8V446.41Z",
    fill: "#22A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.68 446.41H821.8V581.59H823.68V446.41Z",
    fill: "#22A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.56 446.41H823.68V581.59H825.56V446.41Z",
    fill: "#22A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 446.41H825.56V581.59H827.44V446.41Z",
    fill: "#22A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.32 446.41H827.44V581.59H829.32V446.41Z",
    fill: "#22A5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.2 446.41H829.32V581.59H831.2V446.41Z",
    fill: "#23A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.08 446.41H831.2V581.59H833.08V446.41Z",
    fill: "#23A7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.96 446.41H833.08V581.59H834.96V446.41Z",
    fill: "#23A8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.84 446.41H834.96V581.59H836.84V446.41Z",
    fill: "#23A9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.72 446.41H836.84V581.59H838.72V446.41Z",
    fill: "#23AAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.6 446.41H838.72V581.59H840.6V446.41Z",
    fill: "#23ABFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.49 446.41H840.61V581.59H842.49V446.41Z",
    fill: "#23ACFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.37 446.41H842.49V581.59H844.37V446.41Z",
    fill: "#23ADFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.25 446.41H844.37V581.59H846.25V446.41Z",
    fill: "#23AEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.13 446.41H846.25V581.59H848.13V446.41Z",
    fill: "#24AFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.01 446.41H848.13V581.59H850.01V446.41Z",
    fill: "#24B0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.89 446.41H850.01V581.59H851.89V446.41Z",
    fill: "#24B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.77 446.41H851.89V581.59H853.77V446.41Z",
    fill: "#24B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.65 446.41H853.77V581.59H855.65V446.41Z",
    fill: "#24B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.53 446.41H855.65V581.59H857.53V446.41Z",
    fill: "#24B5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.41 446.41H857.53V581.59H859.41V446.41Z",
    fill: "#24B6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.29 446.41H859.41V581.59H861.29V446.41Z",
    fill: "#24B7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.17 446.41H861.29V581.59H863.17V446.41Z",
    fill: "#24B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.05 446.41H863.17V581.59H865.05V446.41Z",
    fill: "#25B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.93 446.41H865.05V581.59H866.93V446.41Z",
    fill: "#25BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.81 446.41H866.93V581.59H868.81V446.41Z",
    fill: "#25BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.69 446.41H868.81V581.59H870.69V446.41Z",
    fill: "#25BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.57 446.41H870.69V581.59H872.57V446.41Z",
    fill: "#25BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.45 446.41H872.57V581.59H874.45V446.41Z",
    fill: "#25BEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.33 446.41H874.45V581.59H876.33V446.41Z",
    fill: "#25BFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.21 446.41H876.33V581.59H878.21V446.41Z",
    fill: "#25C0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.09 446.41H878.21V581.59H880.09V446.41Z",
    fill: "#25C1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.97 446.41H880.09V581.59H881.97V446.41Z",
    fill: "#26C2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.85 446.41H881.97V581.59H883.85V446.41Z",
    fill: "#26C3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.73 446.41H883.85V581.59H885.73V446.41Z",
    fill: "#26C4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.61 446.41H885.73V581.59H887.61V446.41Z",
    fill: "#26C5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.49 446.41H887.61V581.59H889.49V446.41Z",
    fill: "#26C6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.12 446.41H889.49V581.59H892.12V446.41Z",
    fill: "#26C6F9"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M761.24 582.26L760.47 580.91L890.08 506.52C890.51 506.26 890.78 505.8 890.78 505.3L891.34 447.83C891.34 447.65 891.22 447.56 891.16 447.52C891.11 447.49 890.96 447.43 890.8 447.52L761.42 525.61L760.62 524.28L890.01 446.18C890.61 445.83 891.33 445.82 891.94 446.18C892.54 446.53 892.9 447.15 892.9 447.85L892.34 505.32C892.34 506.37 891.79 507.33 890.87 507.88L761.25 582.28L761.24 582.26Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M718.09 499.38L889.66 446.22L849.57 422.5L680.18 477.85L718.09 499.38Z",
    fill: "#8AE6FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M678.28 480.181V532.721L715.72 555.541V500.791L678.28 480.181Z",
    fill: "#76E5FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M643.23 444.041L831.45 410.611L801.97 393.931L706.54 411.241L643.23 444.041Z",
    fill: "#8AE6FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M677.31 347.89L677.96 395.3C677.96 395.98 678.33 396.61 678.92 396.95L759.32 444.01C760.63 444.79 762.25 444.79 763.55 444.01L843.3 398.04C844.02 397.64 844.45 396.86 844.45 396.02V349.89C844.45 349.27 844.11 348.68 843.58 348.36L758.32 298.25L678.14 346.43C677.64 346.74 677.33 347.27 677.33 347.86L677.3 347.89H677.31Z",
    fill: "#26C6F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M761.45 445.37C760.58 445.37 759.71 445.14 758.93 444.68L678.54 397.62C677.71 397.14 677.19 396.25 677.19 395.3L676.53 347.57L676.59 347.51C676.69 346.8 677.11 346.16 677.74 345.77L758.33 297.34L843.99 347.69C844.76 348.14 845.24 348.98 845.24 349.89V396.02C845.24 397.15 844.65 398.18 843.7 398.72L763.96 444.69C763.19 445.15 762.32 445.38 761.46 445.38L761.45 445.37ZM678.1 348.21L678.75 395.29C678.75 395.7 678.97 396.07 679.32 396.27L759.72 443.34C760.79 443.98 762.11 443.98 763.16 443.34L842.92 397.36C843.39 397.1 843.68 396.58 843.68 396.01V349.88C843.68 349.53 843.49 349.2 843.2 349.03L758.34 299.15L678.56 347.09C678.29 347.26 678.13 347.54 678.13 347.86L678.1 348.21Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M843.53 350.76L763.54 396.95C762.23 397.7 760.65 397.7 759.37 396.95L679.84 348.55C678.66 347.83 678.66 346.12 679.84 345.41L758 299.22L843.54 348.46C844.44 348.99 844.44 350.3 843.54 350.79V350.76H843.53Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M761.43 398.28C760.57 398.28 759.72 398.06 758.96 397.61L679.42 349.2C678.63 348.72 678.16 347.89 678.16 346.97C678.16 346.05 678.63 345.21 679.42 344.73L757.98 298.3L758.38 298.52L843.91 347.76C844.59 348.16 844.99 348.86 844.98 349.64C844.97 350.41 844.57 351.08 843.9 351.45L842.74 352.09L763.91 397.6C763.14 398.04 762.28 398.26 761.42 398.26L761.43 398.28ZM758 300.11L680.23 346.07C679.91 346.26 679.73 346.6 679.73 346.98C679.73 347.36 679.92 347.69 680.24 347.88L759.77 396.28C760.79 396.88 762.09 396.88 763.15 396.28L843.3 350C843.41 349.87 843.42 349.72 843.43 349.65C843.43 349.55 843.41 349.29 843.14 349.14L758 300.13V300.11Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3762_33256",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 760,
    y: 351,
    width: 86,
    height: 94
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M760.92 444.51L844.15 398.97C845.02 398.47 845.55 397.54 845.52 396.54L844.49 352.4C844.49 351.31 843.28 350.66 842.34 351.19L760.91 397.47",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3762_33256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M761.01 350.66H760.92V444.51H761.01V350.66Z",
    fill: "#25C1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.3 350.66H761.01V444.51H761.3V350.66Z",
    fill: "#25C0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.59 350.66H761.3V444.51H761.59V350.66Z",
    fill: "#25BFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.88 350.66H761.59V444.51H761.88V350.66Z",
    fill: "#25BEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.16 350.66H761.87V444.51H762.16V350.66Z",
    fill: "#25BDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.45 350.66H762.16V444.51H762.45V350.66Z",
    fill: "#25BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.74 350.66H762.45V444.51H762.74V350.66Z",
    fill: "#24BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.03 350.66H762.74V444.51H763.03V350.66Z",
    fill: "#24B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.32 350.66H763.03V444.51H763.32V350.66Z",
    fill: "#24B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.61 350.66H763.32V444.51H763.61V350.66Z",
    fill: "#24B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.9 350.66H763.61V444.51H763.9V350.66Z",
    fill: "#24B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.19 350.66H763.9V444.51H764.19V350.66Z",
    fill: "#24B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.48 350.66H764.19V444.51H764.48V350.66Z",
    fill: "#23B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.77 350.66H764.48V444.51H764.77V350.66Z",
    fill: "#23B3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.06 350.66H764.77V444.51H765.06V350.66Z",
    fill: "#23B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.35 350.66H765.06V444.51H765.35V350.66Z",
    fill: "#23B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.92 350.66H765.35V444.51H765.92V350.66Z",
    fill: "#23B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.49 350.66H765.92V444.51H766.49V350.66Z",
    fill: "#23B0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.06 350.66H766.49V444.51H767.06V350.66Z",
    fill: "#23AFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.63 350.66H767.06V444.51H767.63V350.66Z",
    fill: "#23AEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.2 350.66H767.63V444.51H768.2V350.66Z",
    fill: "#23ADFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.77 350.66H768.2V444.51H768.77V350.66Z",
    fill: "#23ACFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.34 350.66H768.77V444.51H769.34V350.66Z",
    fill: "#23ABFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.91 350.66H769.34V444.51H769.91V350.66Z",
    fill: "#23AAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.48 350.66H769.91V444.51H770.48V350.66Z",
    fill: "#22A8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.05 350.66H770.48V444.51H771.05V350.66Z",
    fill: "#22A7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.62 350.66H771.05V444.51H771.62V350.66Z",
    fill: "#22A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.19 350.66H771.62V444.51H772.19V350.66Z",
    fill: "#22A5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.76 350.66H772.19V444.51H772.76V350.66Z",
    fill: "#22A4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.33 350.66H772.76V444.51H773.33V350.66Z",
    fill: "#22A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.9 350.66H773.33V444.51H773.9V350.66Z",
    fill: "#22A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.47 350.66H773.9V444.51H774.47V350.66Z",
    fill: "#22A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.47 350.66H774.47V444.51H793.47V350.66Z",
    fill: "#22A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.48 350.66H793.48V444.51H812.48V350.66Z",
    fill: "#22A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.48 350.66H812.48V444.51H831.48V350.66Z",
    fill: "#22A4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.55 350.66H831.49V444.51H845.55V350.66Z",
    fill: "#22A5FE"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M761.29 445.19L760.54 443.82L843.77 398.28C844.38 397.93 844.76 397.27 844.74 396.56L843.71 352.42C843.71 352.1 843.52 351.95 843.4 351.88C843.18 351.76 842.93 351.75 842.72 351.88L761.3 398.17L760.53 396.81L841.96 350.52C842.65 350.13 843.5 350.14 844.19 350.54C844.87 350.94 845.27 351.63 845.27 352.41L846.3 396.53C846.34 397.81 845.66 399.01 844.54 399.65L761.3 445.2L761.29 445.19Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M705.26 227.65L759.89 196.12C760.54 195.75 761.35 195.75 762.01 196.12L816.2 227.4C817.04 227.87 817.54 228.77 817.51 229.73L815.46 292.54C815.46 293.16 815.12 293.72 814.59 294.03L763.01 324.88C761.73 325.66 760.12 325.66 758.84 324.88L705.68 293.29C704.87 292.82 704.37 291.95 704.37 291.02V229.23C704.37 228.58 704.71 227.95 705.3 227.64H705.27L705.26 227.65Z",
    fill: "#26C6F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M760.92 326.26C760.06 326.26 759.2 326.03 758.43 325.56L705.27 293.97C704.23 293.37 703.58 292.25 703.58 291.03V229.24C703.58 228.96 703.62 228.69 703.71 228.43H702.39L704.88 226.98L759.51 195.45C760.4 194.94 761.52 194.94 762.4 195.45L816.59 226.73C817.68 227.33 818.33 228.5 818.29 229.77L816.24 292.58C816.24 293.44 815.76 294.26 814.98 294.72L763.41 325.56C762.65 326.03 761.79 326.26 760.93 326.26H760.92ZM708.17 226.87H708.42L705.66 228.34C705.34 228.51 705.14 228.86 705.14 229.24V291.03C705.14 291.69 705.49 292.3 706.06 292.63L759.23 324.23C760.25 324.85 761.57 324.86 762.6 324.23L814.18 293.38C814.49 293.2 814.67 292.89 814.67 292.56L816.72 229.72C816.74 229.04 816.4 228.41 815.81 228.09L761.61 196.8C761.19 196.56 760.68 196.57 760.27 196.8L708.16 226.88L708.17 226.87Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3762_33256",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 760,
    y: 229,
    width: 58,
    height: 97
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M760.73 257.35L814.2 230.21C815.54 229.46 817.19 230.46 817.16 231.98L816.1 292.18C816.1 293.49 815.35 294.7 814.2 295.35L760.85 325.26",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3762_33256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.73 320.63L761.06 325.26H760.73V320.63Z",
    fill: "#24BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.73 293.95L762.92 325.26H761.06L760.73 320.63V293.95Z",
    fill: "#24BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.73 267.28L764.79 325.26H762.92L760.73 293.95V267.28Z",
    fill: "#24B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.73 240.6L766.65 325.26H764.79L760.73 267.28V240.6Z",
    fill: "#24B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.37 229.46L768.07 325.26H766.65L760.73 240.6V229.46H761.37Z",
    fill: "#24B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.79 229.46L769.49 325.26H768.07L761.37 229.46H762.79Z",
    fill: "#24B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.21 229.46L770.91 325.26H769.49L762.79 229.46H764.21Z",
    fill: "#24B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.63 229.46L772.33 325.26H770.91L764.21 229.46H765.63Z",
    fill: "#24B5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.05 229.46L773.75 325.26H772.33L765.63 229.46H767.05Z",
    fill: "#24B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.47 229.46L775.17 325.26H773.75L767.05 229.46H768.47Z",
    fill: "#24B3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.89 229.46L776.59 325.26H775.17L768.47 229.46H769.89Z",
    fill: "#23B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.31 229.46L778.01 325.26H776.59L769.89 229.46H771.31Z",
    fill: "#23B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.73 229.46L779.43 325.26H778.01L771.31 229.46H772.73Z",
    fill: "#23B0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.15 229.46L780.85 325.26H779.43L772.73 229.46H774.15Z",
    fill: "#23AFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.57 229.46L782.27 325.26H780.85L774.15 229.46H775.57Z",
    fill: "#23AEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.99 229.46L783.69 325.26H782.27L775.57 229.46H776.99Z",
    fill: "#23ADFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.41 229.46L785.11 325.26H783.69L776.99 229.46H778.41Z",
    fill: "#23ABFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.83 229.46L786.53 325.26H785.11L778.41 229.46H779.83Z",
    fill: "#23AAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.24 229.46L787.95 325.26H786.53L779.83 229.46H781.24Z",
    fill: "#23A9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.66 229.46L789.36 325.26H787.95L781.24 229.46H782.66Z",
    fill: "#23A8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.08 229.46L790.78 325.26H789.36L782.66 229.46H784.08Z",
    fill: "#23A7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.5 229.46L792.2 325.26H790.78L784.08 229.46H785.5Z",
    fill: "#22A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.92 229.46L793.62 325.26H792.2L785.5 229.46H786.92Z",
    fill: "#22A5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.34 229.46L795.04 325.26H793.62L786.92 229.46H788.34Z",
    fill: "#22A4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.76 229.46L796.46 325.26H795.04L788.34 229.46H789.76Z",
    fill: "#22A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.18 229.46L797.88 325.26H796.46L789.76 229.46H791.18Z",
    fill: "#22A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.6 229.46L799.3 325.26H797.88L791.18 229.46H792.6Z",
    fill: "#22A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.92 229.46L801.62 325.26H799.3L792.6 229.46H794.92Z",
    fill: "#22A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.24 229.46L803.94 325.26H801.62L794.92 229.46H797.24Z",
    fill: "#22A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.56 229.46L806.26 325.26H803.94L797.24 229.46H799.56Z",
    fill: "#22A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.88 229.46L808.58 325.26H806.26L799.56 229.46H801.88Z",
    fill: "#22A4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.2 229.46L810.9 325.26H808.58L801.88 229.46H804.2Z",
    fill: "#22A5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.52 229.46L813.22 325.26H810.9L804.2 229.46H806.52Z",
    fill: "#23A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.84 229.46L815.54 325.26H813.22L806.52 229.46H808.84Z",
    fill: "#23A7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.16 229.46L817.19 315.76V325.26H815.54L808.84 229.46H811.16Z",
    fill: "#23A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.48 229.46L817.19 282.59V315.76L811.16 229.46H813.48Z",
    fill: "#23A9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.8 229.46L817.19 249.42V282.59L813.48 229.46H815.8Z",
    fill: "#23ABFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.19 249.42L815.8 229.46H817.19V249.42Z",
    fill: "#23ACFD"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M761.24 325.94L760.48 324.58L813.83 294.67C814.75 294.14 815.33 293.19 815.33 292.17L816.39 231.95C816.39 231.52 816.18 231.12 815.8 230.9C815.42 230.67 814.96 230.67 814.59 230.88L761.09 258.04L760.38 256.65L813.85 229.51C814.7 229.04 815.73 229.05 816.59 229.57C817.45 230.09 817.95 230.99 817.93 231.99L816.87 292.19C816.87 293.75 815.99 295.23 814.58 296.03L761.23 325.94H761.24Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M815.36 229.4L768.67 255.36C763.88 258.04 758.06 258.04 753.26 255.36L705.92 229.06C705.24 228.69 705.24 227.69 705.92 227.29L760.08 196.26C760.61 195.95 761.29 195.95 761.82 196.26L815.39 226.92C816.35 227.48 816.35 228.85 815.39 229.41H815.36V229.4Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M760.97 258.15C758.19 258.15 755.42 257.44 752.88 256.03L705.54 229.73C704.98 229.42 704.64 228.85 704.63 228.2C704.63 227.55 704.96 226.93 705.53 226.6L759.7 195.56C760.46 195.11 761.46 195.12 762.22 195.56L815.78 226.22C816.48 226.63 816.9 227.34 816.9 228.14C816.9 228.94 816.48 229.65 815.79 230.06L815.57 230.17L769.06 256.03C766.53 257.44 763.76 258.15 760.98 258.15H760.97ZM760.95 196.79C760.78 196.79 760.62 196.83 760.47 196.91L706.3 227.95C706.19 228.02 706.18 228.13 706.18 228.18C706.18 228.24 706.2 228.32 706.29 228.37L753.64 254.68C758.23 257.24 763.71 257.24 768.29 254.68L815.11 228.65C815.31 228.48 815.34 228.25 815.34 228.15C815.34 228.04 815.31 227.75 815 227.58L761.44 196.92C761.29 196.83 761.12 196.79 760.95 196.79Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3762_33256",
    x: 10.08,
    y: 10.96,
    width: 1007.68,
    height: 1066.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.305882 0 0 0 0 0.392157 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3762_33256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3762_33256",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3762_33256",
    x1: 881.56,
    y1: 271.36,
    x2: 632.02,
    y2: 662.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A42A49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3762_33256",
    x1: 480.67,
    y1: 519.77,
    x2: 120.71,
    y2: 879.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4B4BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2635A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3762_33256",
    x1: 67.7999,
    y1: 411.76,
    x2: 130.86,
    y2: 411.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4B4BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2635A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3762_33256",
    x1: 149.86,
    y1: 401.62,
    x2: 286.71,
    y2: 401.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4B4BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2635A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3762_33256",
    x1: 149.86,
    y1: 420.77,
    x2: 233.04,
    y2: 420.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4B4BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2635A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3762_33256",
    x1: 215.79,
    y1: 547.39,
    x2: 275.67,
    y2: 826.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FCE37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDAC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF4D49"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropImg);
export default __webpack_public_path__ + "static/media/drag_drop_img.51188f62cf70bd6a9cac3a1e8e38c764.svg";
export { ForwardRef as ReactComponent };